import { FC } from 'react';
import { lt } from '@mews/framework';
import { Icon, IconName, Stack, Tag, Tooltip, Typography } from '@optimus-web/core';
import { SubSection as SubSectionType } from '../types';
import { SubSectionLine } from './SubSectionLine';

interface SubSectionProps {
    subSection: SubSectionType;
}

export const SubSection: FC<SubSectionProps> = ({ subSection }) => {
    const { title, helpText, lines, tag } = subSection;

    return (
        <Stack vertical spacing="200">
            {title && (
                <Stack distribution="space-between">
                    <Typography textStyle="bodyLargeStrong" as="div">
                        {title}
                    </Typography>
                    <Stack itemAlignment="center" spacing="100">
                        {tag && <Tag variant={tag.variant}>{lt(tag.textKey)}</Tag>}
                        {helpText && <TooltipIcon size="small" value={IconName.Help} tooltip={helpText} />}
                    </Stack>
                </Stack>
            )}
            <Stack vertical alignment="center" spacing="100">
                {lines.map((line, index) => {
                    const key = `line-${index}`;

                    return <SubSectionLine key={key} line={line} dataTestId={key} />;
                })}
            </Stack>
        </Stack>
    );
};

const TooltipIcon = Tooltip(Icon);
